<app-nav-bar [appTitle]="headerDisplayName" [isAppMenuShow]='hasPermission$ | async' [additionalMenuItems]="extraMenuItems"></app-nav-bar>
<div class="wrapper">
  <div class="container">
    <div class="router-container">
      <router-outlet></router-outlet>
    </div>
    <app-footer [version]='version'></app-footer>
  </div>
  
</div>
